import { __assign, __spreadArrays } from "tslib";
import omit from 'lodash/omit';
import { filterAndSortCategories, sortAlphabetically, } from '../../shared/utils';
import { ContentActionTypes, } from '../actions/content.actions';
export var initialState = {
    templates: [],
    loadingContentEntry: false,
    errors: {
        loadingContentEntry: false,
    },
    activeContent: {},
    contentHeaders: {},
    categories: [],
    isSavingContentEntry: false,
};
export function reducer(state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        // Templates
        // ================================================
        case ContentActionTypes.GetTemplatesSuccess: {
            return __assign(__assign({}, state), { templates: action.payload });
        }
        case ContentActionTypes.CreateTemplateSuccess: {
            return __assign(__assign({}, state), { templates: state.templates.concat(action.payload) });
        }
        case ContentActionTypes.SavingTemplateSuccess: {
            return __assign(__assign({}, state), { templates: state.templates.map(function (t) {
                    return t.id === action.payload.id ? action.payload : t;
                }) });
        }
        case ContentActionTypes.DeleteTemplateSuccess: {
            return __assign(__assign({}, state), { templates: state.templates.filter(function (t) { return t.id !== action.payload; }) });
        }
        // Content Entries
        // ================================================
        case ContentActionTypes.GetContentEntry: {
            return __assign(__assign({}, state), { activeContent: {}, loadingContentEntry: true, errors: {
                    loadingContentEntry: false,
                } });
        }
        case ContentActionTypes.GetContentEntrySuccess: {
            return __assign(__assign({}, state), { loadingContentEntry: false, activeContent: action.payload, errors: {
                    loadingContentEntry: false,
                } });
        }
        case ContentActionTypes.GetContentEntryError: {
            return __assign(__assign({}, state), { loadingContentEntry: false, errors: {
                    loadingContentEntry: true,
                } });
        }
        case ContentActionTypes.GetContentEntriesSuccess: {
            return __assign(__assign({}, state), { contentHeaders: action.payload });
        }
        case ContentActionTypes.CreateEntry: {
            return __assign(__assign({}, state), { isSavingContentEntry: true });
        }
        case ContentActionTypes.CreateEntrySuccess: {
            return __assign(__assign({}, state), { activeContent: __assign(__assign({}, state.activeContent), (_a = {}, _a[action.payload.languageCode] = action.payload.contentEntry, _a)), isSavingContentEntry: false });
        }
        case ContentActionTypes.CreateEntryError: {
            return __assign(__assign({}, state), { isSavingContentEntry: false });
        }
        case ContentActionTypes.CreateNewContentEntry: {
            return __assign(__assign({}, state), { activeContent: __assign(__assign({}, state.activeContent), (_b = {}, _b[action.payload.languageCode] = action.payload.contentEntry, _b)) });
        }
        case ContentActionTypes.SaveEntry: {
            return __assign(__assign({}, state), { isSavingContentEntry: true });
        }
        case ContentActionTypes.SaveEntrySuccess: {
            return __assign(__assign({}, state), { activeContent: __assign(__assign({}, state.activeContent), (_c = {}, _c[action.payload.languageCode] = action.payload.contentEntry, _c)), isSavingContentEntry: false });
        }
        case ContentActionTypes.SaveEntryError: {
            return __assign(__assign({}, state), { isSavingContentEntry: false });
        }
        case ContentActionTypes.DeleteEntrySuccess: {
            return __assign(__assign({}, state), { activeContent: omit(state.activeContent, action.payload.languageCode) });
        }
        case ContentActionTypes.DeleteEntriesSuccess: {
            var _g = action.payload, removedEntries_1 = _g.entries, categoryId = _g.categoryId;
            var changedEntries = state.contentHeaders[categoryId].filter(function (c) { return removedEntries_1.indexOf(c.id) === -1; });
            return __assign(__assign({}, state), { contentHeaders: __assign(__assign({}, state.contentHeaders), (_d = {}, _d[categoryId] = changedEntries, _d)) });
        }
        case ContentActionTypes.MoveEntriesSuccess: {
            var _h = action.payload, entries = _h.entries, newCategoryId = _h.newCategoryId, oldCategoryId = _h.oldCategoryId;
            var _j = splitEntries(state.contentHeaders[oldCategoryId], entries), toKeep = _j.toKeep, toRemove = _j.toRemove;
            return __assign(__assign({}, state), { contentHeaders: __assign(__assign({}, state.contentHeaders), (_e = {}, _e[oldCategoryId] = toKeep, _e[newCategoryId] = state.contentHeaders[newCategoryId].concat(toRemove), _e)) });
        }
        // Content Categories
        // ================================================
        case ContentActionTypes.GetCategoriesSuccess: {
            return __assign(__assign({}, state), { categories: action.payload });
        }
        case ContentActionTypes.CreateCategorySuccess: {
            return __assign(__assign({}, state), { categories: __spreadArrays(state.categories, [action.payload]), contentHeaders: __assign(__assign({}, state.contentHeaders), (_f = {}, _f[action.payload.id] = [], _f)) });
        }
        case ContentActionTypes.SavingCategorySuccess: {
            var updatedCategory_1 = action.payload;
            return __assign(__assign({}, state), { categories: state.categories.map(function (c) {
                    return c.id === updatedCategory_1.id ? __assign(__assign({}, c), updatedCategory_1) : c;
                }) });
        }
        case ContentActionTypes.DeleteCategorySuccess: {
            var id_1 = action.payload;
            var newContentHeaders = __assign({}, state.contentHeaders);
            delete newContentHeaders[id_1];
            return __assign(__assign({}, state), { categories: state.categories.filter(function (c) { return c.id !== id_1; }), contentHeaders: newContentHeaders });
        }
        case ContentActionTypes.ContentEntryPageUnload: {
            return __assign(__assign({}, state), { activeContent: {} });
        }
        case ContentActionTypes.CopyGlobalContent: {
            var activeContent = Object.keys(action.payload).reduce(function (agg, key) {
                var _a;
                return __assign(__assign({}, agg), (_a = {}, _a[key] = __assign(__assign(__assign({}, state.activeContent[key]), (!state.activeContent[key].fromdatasync && {
                    name: action.payload[key].name,
                })), { sections: action.payload[key].sections }), _a));
            }, __assign({}, state.activeContent));
            return __assign(__assign({}, state), { activeContent: activeContent });
        }
        case ContentActionTypes.CopyGlobalFileContent: {
            var activeContent = Object.keys(action.payload).reduce(function (agg, key) {
                var _a;
                return __assign(__assign({}, agg), (_a = {}, _a[key] = __assign(__assign(__assign({}, state.activeContent[key]), (!state.activeContent[key].fromdatasync && {
                    name: action.payload[key].name,
                })), { sections: action.payload[key].sections, attachments: action.payload[key].attachments }), _a));
            }, __assign({}, state.activeContent));
            return __assign(__assign({}, state), { activeContent: activeContent });
        }
        default: {
            return state;
        }
    }
}
export var getTemplates = function (state) {
    return state.templates.sort(sortAlphabetically);
};
export var getContentHeaders = function (state) { return state.contentHeaders; };
export var getActiveContent = function (state) { return state.activeContent; };
export var getCategories = function (state) {
    return filterAndSortCategories(state.categories);
};
export var getGeneralCategories = function (state) {
    return filterAndSortCategories(state.categories.filter(function (c) { return !c.patientonly; }));
};
export var isLoadingContentEntry = function (state) {
    return state.loadingContentEntry;
};
export var getIsSavingContentEntry = function (state) {
    return state.isSavingContentEntry;
};
export var getLoadingErrors = function (state) { return state.errors; };
export var loadingContentEntryError = function (state) {
    return state.errors.loadingContentEntry;
};
function splitEntries(entries, entriesToRemove) {
    var toRemove = [];
    var toKeep = [];
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var entry = entries_1[_i];
        if (entriesToRemove.indexOf(entry.id) === -1) {
            toKeep.push(entry);
        }
        else {
            toRemove.push(entry);
        }
    }
    return {
        toRemove: toRemove,
        toKeep: toKeep,
    };
}
